module.exports = __webpack_public_path__ + "static/img/logo.cb79fc6c.png";